import React, { useEffect, useState, useCallback } from "react";

function RendezVous({ clientId }) {
  const [rdvs, setRdvs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);

  const [formData, setFormData] = useState({
    type: "Au Cabinet",
    dateRdv: "",
    heureRdv: "",
    objetRdv: "",
    note: "",
  });

  // 🔄 Récupération des RDV
  const fetchRdvs = useCallback(() => {
    if (!clientId) return;

    setLoading(true);
    fetch(`https://backend-myalfa.vercel.app/api/rdv/client/${clientId}`)
      .then((res) => res.json())
      .then((data) => {
        setRdvs(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [clientId]);

  useEffect(() => {
    fetchRdvs();
  }, [fetchRdvs]);

  // ➕ Ajouter un RDV
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoadingForm(true);

    fetch("https://backend-myalfa.vercel.app/api/rdv", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...formData,
        clientId,
        dateRdv: new Date(
          `${formData.dateRdv}T${formData.heureRdv}:00`
        ).toISOString(),
      }),
    })
      .then((res) => res.json())
      .then(() => {
        fetchRdvs();
        setShowForm(false);
        setFormData({
          type: "Au Cabinet",
          dateRdv: "",
          heureRdv: "",
          objetRdv: "",
          note: "",
        });
      })
      .finally(() => setLoadingForm(false));
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h3 className="text-xl font-semibold">Rendez-vous</h3>
        <button
          onClick={() => setShowForm(!showForm)}
          className="px-4 py-2 bg-[#8B1538] text-white rounded"
        >
          Ajouter un RDV
        </button>
      </div>

      {/* Formulaire */}
      {showForm && (
        <form onSubmit={handleSubmit} className="p-4 border rounded space-y-4">
          {/* Type */}
          <div>
            <label className="block text-sm font-medium mb-1">Type</label>
            <select
              className="w-full border rounded p-2"
              value={formData.type}
              onChange={(e) =>
                setFormData({ ...formData, type: e.target.value })
              }
            >
              <option>Visioconférence</option>
              <option>Téléphonique</option>
              <option>Au Cabinet</option>
            </select>
          </div>

          {/* Date */}
          <div>
            <label className="block text-sm font-medium mb-1">Date</label>
            <input
              type="date"
              className="w-full border rounded p-2"
              value={formData.dateRdv}
              onChange={(e) =>
                setFormData({ ...formData, dateRdv: e.target.value })
              }
              required
            />
          </div>

          {/* Heure */}
          <div>
            <label className="block text-sm font-medium mb-1">Heure</label>
            <input
              type="time"
              className="w-full border rounded p-2"
              value={formData.heureRdv}
              onChange={(e) =>
                setFormData({ ...formData, heureRdv: e.target.value })
              }
              required
            />
          </div>

          {/* Objet */}
          <div>
            <label className="block text-sm font-medium mb-1">Objet</label>
            <input
              className="w-full border rounded p-2"
              value={formData.objetRdv}
              onChange={(e) =>
                setFormData({ ...formData, objetRdv: e.target.value })
              }
              required
            />
          </div>

          {/* Note */}
          <div>
            <label className="block text-sm font-medium mb-1">Note</label>
            <textarea
              className="w-full border rounded p-2"
              rows="3"
              value={formData.note}
              onChange={(e) =>
                setFormData({ ...formData, note: e.target.value })
              }
            />
          </div>

          <button className="px-4 py-2 bg-green-600 text-white rounded">
            {loadingForm ? "Création..." : "Créer le rendez-vous"}
          </button>
        </form>
      )}

      {/* Chargement */}
      {loading && <p>Chargement des rendez-vous...</p>}

      {/* Liste des RDV */}
      {!loading && (
        <ul className="space-y-3">
          {rdvs.length === 0 && (
            <p className="text-sm text-gray-500">Aucun rendez-vous</p>
          )}

          {rdvs.map((r) => (
            <li key={r.id} className="border p-4 rounded">
              <p className="font-medium">{r.objetRdv}</p>
              <p className="text-sm">Type : {r.type}</p>
              <p className="text-sm">
                Date : {new Date(r.dateRdv).toLocaleDateString()} à {r.heureRdv}
              </p>
              {r.note && <p className="text-sm text-gray-600">{r.note}</p>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default RendezVous;
